import React, { Dispatch, SetStateAction, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import Flex from "../../../../DefaultStyles/Flex";
import CalendarModal from "../../../../Modal/CalendarModal";
import ToolTip from "../../../../Modal/ToolTip";
import { SearchTag } from "./OldChatSeachResult";
import { CalendarLine } from "./OldRecentChat";

interface RecentChatHeaderProps {
  dropDownValue: {
    label?: string;
  };
  searchValue?: string;
  setDateData: Dispatch<SetStateAction<any>>;
}

export default function RecentChatHeader({
  setDateData,
  dropDownValue,
  searchValue,
}: RecentChatHeaderProps) {
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <RecentChatHeaderContainer>
      <Flex>
        <>
          {dropDownValue?.label?.split("@")[0] &&
            searchValue?.split("@")[0] && (
              <SearchTag
                onClick={() => {
                  if (dropDownValue?.label?.includes("PID")) {
                    navigate(`/party/info/${searchValue?.split("@")[0]}`);
                  } else {
                    navigate(`/users/info/${searchValue?.split("@")[0]}`);
                  }
                }}
                isClickable={true}
              >
                {dropDownValue?.label?.split("@")[0]}_
                {searchValue?.split("@")[0]}
              </SearchTag>
            )}
        </>

        <>
          {dropDownValue?.label?.split("@")[1] &&
            searchValue?.split("@")[1] && (
              <SearchTag
                isClickable={true}
                onClick={() => {
                  if (dropDownValue?.label?.split("@")[1]) {
                    navigate(`/users/info/${searchValue?.split("@")[1]}`);
                  }
                }}
              >
                {dropDownValue?.label?.split("@")[1]}
                {" UID"}_{searchValue?.split("@")[1]}
              </SearchTag>
            )}
        </>

        <>
          {dropDownValue?.label?.split("@")[2] &&
            searchValue?.split("@")[2] && (
              <SearchTag
                isClickable={true}
                onClick={() => {
                  if (dropDownValue?.label?.split("@")[2]) {
                    navigate(`/users/info/${searchValue?.split("@")[2]}`);
                  }
                }}
              >
                {dropDownValue?.label?.split("@")[2]}
                {" UID"}_{searchValue?.split("@")[2]}
              </SearchTag>
            )}
        </>
      </Flex>

      <Flex gapSize={10}>
        <ToolTip msg="한 번에 최대 7일까지 조회 가능" direction="top" />

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setStartDateClick(true)}
            value={startDate}
            initValue={"날짜 선택"}
          />

          {startDateClick && (
            <CalendarModal
              closeEvent={() => setStartDateClick(false)}
              changeEvent={(date: string) => setStartDate(date)}
              sPosition="absolute"
              isAllSelectable={true}
            />
          )}
        </LineBoxContainer>

        <CalendarLine />

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setEndDateClick(true)}
            value={endDate}
            initValue={"날짜 선택"}
            disabled={startDate === "날짜 선택"}
          />

          {endDateClick && (
            <CalendarModal
              closeEvent={() => setEndDateClick(false)}
              changeEvent={(date: string) => setEndDate(date)}
              sPosition="absolute"
              dateValue={startDate}
            />
          )}
        </LineBoxContainer>

        <ConfirmBtn
          btnColor="mint"
          btnText="적용"
          btnHeight={38}
          isDisabled={startDate === "날짜 선택" || endDate === "날짜 선택"}
          btnClickEvent={() => {
            setDateData({
              btn: true,
              startDate: startDate,
              endDate: endDate,
            });
          }}
        />

        <LineBtn
          btnColor="mint"
          btnText="초기화"
          icon="refresh"
          btnHeight={38}
          disabled={startDate === "날짜 선택" && endDate === "날짜 선택"}
          btnClickEvent={() => {
            setDateData({
              btn: false,
              startDate: "날짜 선택",
              endDate: "날짜 선택",
            });
            setStartDate("날짜 선택");
            setEndDate("날짜 선택");
          }}
        />
      </Flex>
    </RecentChatHeaderContainer>
  );
}

const RecentChatHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  @media screen and (max-width: 1300px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
